import {createApiFetcher, SpringPageable} from "@variocube/app-ui";
import {TypeOf} from "zod";
import {CreditCard, CreditCardCreation, CreditCardMutation, get_QueryCreditCards, useApiClient} from "./client";

export type CreditCardQuery = TypeOf<get_QueryCreditCards["parameters"]>["query"];
export type CreditCardFilter = Omit<CreditCardQuery, keyof SpringPageable>;

export function useCreditCardApi() {
	const api = useApiClient();
	const {fetch} = createApiFetcher("");

	return {
		importCreditCards: async (file: File) => {
			const formData = new FormData();
			formData.append("file", file);

			const response = await fetch(`/api/v2/credit-cards/import`, {
				method: "POST",
				body: formData,
			});

			return await response.json() as CreditCard[];
		},
		exportCreditCards: async () => {
			location.href = "/api/v2/credit-cards/export";
		},
		queryCreditCards: (query: CreditCardQuery) => api.get("/api/v2/credit-cards", {query}),
		getCreditCard: (id: number) => api.get("/api/v2/credit-cards/{id}", {path: {id}}),
		createCreditCard: (creation: CreditCardCreation) => api.post("/api/v2/credit-cards", {body: creation}),
		updateCreditCard: (id: number, update: CreditCardMutation) =>
			api.put(`/api/v2/credit-cards/{id}`, {
				path: {id},
				body: update,
			}),
		deleteCreditCard: (id: number) => api.delete(`/api/v2/credit-cards/{id}`, {path: {id}}),
	};
}
